/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
import React, { Children } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "antd/dist/antd.css";
import "./App.scss";
import ShipmentTracker from "./views/ShipmentTracker";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const PageNotFound = React.lazy(() => import("./views/404"));

const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <Navbar />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

const routes = [
  {
    path: "/",
    element: <ShipmentTracker />,
  },
  {
    path: "/ecommerce-tracking",
    element: <ShipmentTracker />,
  },
  {
    path: "/track-order/:trackingId",
    element: <ShipmentTracker />,
  },
  {
    path: "/customer-tracking-web-page/:trackingId",
    element: <ShipmentTracker />,
  },
  {
    path: "/:trackingId",
    element: <ShipmentTracker />,
  },
];

const App = () => {
  return (
    <BrowserRouter basename="/">
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
          />
        ))}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
